import { render, staticRenderFns } from "./AboutGoToGifteeTopSection.vue?vue&type=template&id=4a6b3511&scoped=true&"
import script from "./AboutGoToGifteeTopSection.vue?vue&type=script&lang=js&"
export * from "./AboutGoToGifteeTopSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutGoToGifteeTopSection.vue?vue&type=style&index=0&id=4a6b3511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b3511",
  null
  
)

export default component.exports